import React from 'react';
import DeveloperAppSetupModal from '../apps/DeveloperAppSetupModal';

export default function TwitchAppSetup(props) {
  return <DeveloperAppSetupModal provider="twitch" {...props} />;
}
